import { ChatNames } from '../types/Chat';

/**
 * `Chats.name` delle chat AI resta in italiano perché il digest push lo compone
 * server-side, senza i18n: a FE la label passa dalle traduzioni.
 */
export function aiChatTitleKey(kind: ChatNames['kind']): string | null {
  if (kind === 'story') return 'common.storyChatName';
  if (kind === 'lore') return 'common.loreChatName';
  return null;
}
